export default __webpack_public_path__ + "d0cc1158a1b3bd75bb785cd0d6e306c1.png";